module.exports = __webpack_public_path__ + "img/vulcans2.5dd77c3.jpg";